import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { ArchiveHeader } from "@/features/newsletter/modules/newsletter-archive/components/archive-header";
import { NewsletterSignup } from "@/features/newsletter/modules/newsletter-signup/newsletter-signup";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(public)/newsletter/unsubscribe/")({
  component: RouteComponent,
  loader: () => ({ crumb: m.newsletter_unsubscribe_crumb() }),
  validateSearch: z.object({
    token: z.string().optional(),
  }),
});

function RouteComponent() {
  const { token } = Route.useSearch();
  return (
    <div className="min-h-svh px-6 py-10 md:py-14">
      <ArchiveHeader />
      <div className="mx-auto flex w-full max-w-2xl items-center" data-tour="newsletter-unsubscribe">
        <NewsletterSignup unsubscribeToken={token ?? "00000000-0000-0000-0000-000000000000"} />
      </div>
    </div>
  );
}
